import { useAddToCartFromUrl } from '@/composables/useAddToCartFromUrl';

/**
 * Global add-to-cart plugin.
 * Handles the ?sku=X&atc=1 URL format on any page (collections, home, etc.)
 *
 * PDP-specific add-to-cart (?atc=2, ?atc=SKU,qty) is handled by ConversionAreaOne
 * using the same composable with pre-loaded product data.
 */
export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook('app:mounted', async () => {
    const { handleAddToCartFromUrl } = useAddToCartFromUrl();

    // Only handles global target - PDP target is handled by ConversionAreaOne
    await handleAddToCartFromUrl();
  });
});
